export default {
  SET_THEME: 'SET_THEME'
}
